import { useCallback, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { buildReturnToParam } from "../utils/listNavigation";
import { usePersistListQuery, useRestoreListQuery } from "./useListQueryPersistence";

/**
 * Persist list filters/pagination and expose returnTo for detail links.
 */
export function useListPersistence(listPath, persistedState, applyRestoredState) {
  const [searchParams] = useSearchParams();
  const skipPageResetRef = useRef(true);

  const wrappedApply = useCallback(
    (saved) => {
      skipPageResetRef.current = true;
      applyRestoredState(saved);
      window.setTimeout(() => {
        skipPageResetRef.current = false;
      }, 0);
    },
    [applyRestoredState]
  );

  useRestoreListQuery(listPath, wrappedApply);
  usePersistListQuery(listPath, persistedState);

  useEffect(() => {
    skipPageResetRef.current = false;
  }, []);

  const returnToParam = buildReturnToParam(listPath, searchParams);

  return {
    skipPageResetRef,
    returnToParam,
    detailListQuery: returnToParam ? `&returnTo=${returnToParam}` : "",
  };
}
